<a-center-container>
  <div class="popup_container">
    <a-loader></a-loader>
    <iframe [src]="iFrameSrc"></iframe>
  </div>
  <overlay (click)="onClose()"></overlay>
</a-center-container>
